// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { AttachmentOut } from './attachmentOut.zod.ts';
import { PersonRef } from './personRef.zod.ts';

export const activityOutAttachmentsDefault = [];

export const ActivityOut = zod.object({
  "attachments": zod.array(AttachmentOut).default(activityOutAttachmentsDefault),
  "author": PersonRef,
  "body": zod.union([zod.string(),zod.null()]),
  "by_requester": zod.boolean(),
  "created_at": zod.iso.datetime({"offset":true}),
  "from_status": zod.union([zod.enum(['new', 'in_review', 'planned', 'in_progress', 'resolved', 'declined', 'cancelled']),zod.null()]),
  "id": zod.uuid(),
  "kind": zod.enum(['comment', 'status']),
  "to_status": zod.union([zod.enum(['new', 'in_review', 'planned', 'in_progress', 'resolved', 'declined', 'cancelled']),zod.null()])
});

export type ActivityOut = zod.input<typeof ActivityOut>;
export type ActivityOutOutput = zod.output<typeof ActivityOut>;
